/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
    <div id="appWrap" :class="{'modal-open': modalOpen }">
        <div id="app">
            <page-header></page-header>
            <router-view/>
            <footer id="pageFooter">
                <div id="footerText">Presented by</div>
                <a href="https://www.indiancarbon.org/"><img src="./assets/nicc-logo.png" alt="National Indian Carbon Coalition" id="niccLogo"></a>
                <div id="sdashCredit">Powered by <a href="https://green2sustainable.com">Green2Sustainable</a></div>
                <div id="tnc">
                    <a href="https://www.green2sustainable.com/tos">Terms of Service</a>
                    <a href="https://www.green2sustainable.com/privacy">Privacy Policy</a>
                </div>
            </footer>
        </div>
    </div>
</template>

<style lang="less">
    @import (reference) "./assets/variables";

    html, body {
        font-family: "Archivo Narrow", sans-serif;
        font-size: 14pt;
        color: @text-color;
        margin: 0;
        padding: 0;
        height: 100%;
        background: url("./assets/bg.png");
    }
    h1, h2, h3, h4, h5, h6{
        font-family: "Archivo Black", serif;
        font-weight: normal;
    }
    h1{
        font-size: 2.4rem;
    }
    h2{
        font-size: 1.4rem;
    }
    a:link, a:visited{
        color: @green;
        &.button{
            color: white;
        }
    }
    a:hover{
        color: lighten(@green, 5%);
        text-decoration: none;
        &.button{
            color: white;
        }
    }
    input[type=text], input[type=email], input[type=number], textarea, select{
        font-size: .85rem;
        padding: 0.5em;
        margin: 0.5em 0;
        width: 100%;
        box-sizing: border-box;
        border: 0;
        background: transparent;
        &::placeholder{
            color: @gray;
        }
        &.dark{
            color: white;
            border-bottom: 2px solid @light-green;
            &::placeholder{
                color: @light-green;
            }
        }
    }
    select{
        appearance: none;
    }
    select:invalid{
        color: @gray;
        & option:not(:disabled){
            color: @text-color;
        }
    }
    label.select-wrap{
        display: flex;
        flex: 1;
        position: relative;
        align-items: center;
        /*.select-drop{*/
        /*    position: absolute;*/
        /*    right: 0;*/
        /*    top: 0.75em;*/
        /*}*/
        &:after{
            content: "\f078";
            .font-awesome();
            color: @lightest-gray;
            position: absolute;
            right: 0.25em;
            z-index: -1;
        }
    }

    #appWrap{
        width: 100%;
        min-height: 100%;
        padding-bottom: calc(200px + 2.5rem);
        box-sizing: border-box;
        position: relative;
        &.modal-open{
            height: 100%;
            overflow: hidden;
        }
    }
    #app{
        max-width: 800px;
        margin: 0 auto;
        padding: 0;
        text-align: center;
        position: relative;
        box-sizing: border-box;
    }
    @keyframes spinner {
        0% {
            transform: translate3d(-50%, -50%, 0) rotate(0deg);
        }
        100% {
            transform: translate3d(-50%, -50%, 0) rotate(360deg);
        }
    }
    .button-submit{
        .button();
        &.loading:after{
            content: '\f110';
            position: relative;
            top: 0.8em;
            left: 0.5em;
            animation: 2s linear infinite spinner;
        }
    }
    .calculator-form-list{
        padding: 0;
        list-style: none;
        margin-bottom: 2em;
        .calculator-form-title{
            font-weight: 700;
            font-size: 1rem;
            width: 100%;
            text-align: left;
            margin: 0 0 0.2em;
            color: @gray;
        }
        .calculator-form-item{
            display: flex;
            align-items: center;
            position: relative;
            margin: 1em 0;
            padding: 0.5em 0 0;
            flex-wrap: wrap;
            border-bottom: 2px solid @lightest-gray;
            input, select{
                width: auto;
                flex: 1;
            }
        }
        .form-icon{
            font-size: 1.4rem;
            min-width: 30px;
            max-width: 30px;
            text-align: center;
            color: @gray;
            margin-right: 0.5em;
        }
        .form-error{
            color: @red;
            position: absolute;
            right: 0;
            top: 0.75rem;
        }
    }
    #pageFooter{
        border-top: 3px solid @light-gray;
        width: 100%;
        position: absolute;
        text-align: center;
        left: 50%;
        bottom: calc(-200px - 2.5rem);;
        margin: 0 -50%;
        box-sizing: border-box;
        height: 200px;
        padding: 1.3rem;
    }
    #footerText{
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: @light-gray;
        margin-bottom: 0.5rem;
    }
    #sdashCredit, #tnc{
        font-size: 0.8rem;
        margin: 0.3em 0;
        a:link, a:visited{
            color: @text-color;
        }
    }
    #tnc a{
        margin: 0 1em;
    }
    .clearfix{
        clear: both;
    }
</style>

<script>
    // import 'semantic-ui-css/semantic.min.css';
    import PageHeader from "./components/PageHeader";
    import "@fortawesome/fontawesome-free/css/all.css";

    export default {
        name: 'app',
        components: {PageHeader},
        data: function() {
            return {
                authenticated: false,
                modalOpen: false
            };
        },
        computed: {
            modalState() {
                return this.$store.getters["modalOpen"];
            }
        },
        created() {
            this.isAuthenticated();
        },
        watch: {
            // Everytime the route changes, check for auth status and scroll to top of the page
            '$route': function() {
                this.isAuthenticated();
                window.scrollTo(window.scrollX, 0);
            },
            modalState(newState, oldState) {
                this.modalOpen = newState;
            }
        },
        methods: {
            async isAuthenticated() {
                this.authenticated = await this.$auth.isAuthenticated();
            },
            async logout() {
                await this.$auth.logout();
                await this.isAuthenticated();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/App.vue